import { call, put, all, takeLatest } from "redux-saga/effects";
import * as api from "constants/api";
import { handleError } from "./ApiError";
import {
    GET_ACTION_UPDATES,
    SG_GET_ACTION_UPDATES,
    FETCH_ACTION_UPDATE,
    SG_FETCH_ACTION_UPDATE,
    GET_UPDATES_ACTIVITY_FEED,
    SG_GET_UPDATES_ACTIVITY_FEED,
} from "constants/actions";

/* Updates */

function* loadActionUpdates(action) {
    try {
        const json = yield call(api.GET_APV2_UPDATES, action.payload);
        yield put({ type: GET_ACTION_UPDATES, payload: json.data });
    } catch (e) {
        yield call(handleError, e);
    }
}

export function* actionUpdatesLoad() {
    yield takeLatest(SG_GET_ACTION_UPDATES, loadActionUpdates);
}

function* fetchActionUpdate(action) {
    try {
        const json = yield call(api.FETCH_APV2_UPDATE, action.payload);
        yield put({ type: FETCH_ACTION_UPDATE, payload: json.data });
    } catch (e) {
        yield call(handleError, e);
    }
}

export function* actionUpdateFetch() {
    yield takeLatest(SG_FETCH_ACTION_UPDATE, fetchActionUpdate);
}

function* loadUpdatesActivityFeed(action) {
    try {
        const json = yield call(api.UPDATE_ACTIVITY_FEED, action.payload);
        yield put({ type: GET_UPDATES_ACTIVITY_FEED, payload: json.data });
    } catch (e) {
        yield call(handleError, e);
    }
}

export function* updatesActivityFeedLoad() {
    yield takeLatest(SG_GET_UPDATES_ACTIVITY_FEED, loadUpdatesActivityFeed);
}

export default function* index() {
    yield all([
        actionUpdatesLoad(),
        actionUpdateFetch(),
        updatesActivityFeedLoad(),
    ]);
}
